module.exports = __webpack_public_path__ + "static/media/christian-dior-hypnotic-poison-big.bfd4a287.png";